import { css } from '@emotion/react'
import { s3URL } from '@mathflat/common/util'

export const fonts = css`
  @font-face {
    font-family: 'Pretendard';
    font-weight: 100;
    font-display: swap;
    src:
      local('Pretendard Thin'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Thin.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Thin.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Thin.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Thin.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 200;
    font-display: swap;
    src:
      local('Pretendard ExtraLight'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-ExtraLight.woff2')})
        format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-ExtraLight.woff')})
        format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-ExtraLight.ttf')})
        format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-ExtraLight.otf')})
        format('opentype');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 300;
    font-display: swap;
    src:
      local('Pretendard Light'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Light.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Light.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Light.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Light.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 400;
    font-display: swap;
    src:
      local('Pretendard Regular'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Regular.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Regular.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Regular.ttf')})
        format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Regular.otf')})
        format('opentype');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 500;
    font-display: swap;
    src:
      local('Pretendard Medium'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Medium.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Medium.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Medium.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Medium.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 600;
    font-display: swap;
    src:
      local('Pretendard SemiBold'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-SemiBold.woff2')})
        format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-SemiBold.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-SemiBold.ttf')})
        format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-SemiBold.otf')})
        format('opentype');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 700;
    font-display: swap;
    src:
      local('Pretendard Bold'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Bold.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Bold.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Bold.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Bold.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 800;
    font-display: swap;
    src:
      local('Pretendard ExtraBold'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-ExtraBold.woff2')})
        format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-ExtraBold.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-ExtraBold.ttf')})
        format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-ExtraBold.otf')})
        format('opentype');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 900;
    font-display: swap;
    src:
      local('Pretendard Black'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Black.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Black.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Black.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('pretendard/Pretendard-Black.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 700;
    src:
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Bold.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Bold.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Bold.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 500;
    src:
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Medium.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Medium.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Medium.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 400;
    src:
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Regular.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Regular.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Regular.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 300;
    src:
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Light.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Light.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Light.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 100;
    src:
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Light.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Light.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('SpoqaHanSansNeo-Light.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'ChosunSm';
    src: url(${s3URL.mathflatAssetsBucket.font('ChosunSm.TTF')}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Godo';
    font-style: normal;
    font-weight: 400;
    src:
      url(${s3URL.mathflatAssetsBucket.font('GodoM.otf')}) format('opentype'),
      url(${s3URL.mathflatAssetsBucket.font('GodoM.ttf')}) format('truetype');
  }

  @font-face {
    font-family: 'Godo B';
    font-style: normal;
    font-weight: 700;
    src:
      url(${s3URL.mathflatAssetsBucket.font('GodoB.otf')}) format('opentype'),
      url(${s3URL.mathflatAssetsBucket.font('GodoB.ttf')}) format('truetype');
  }

  @font-face {
    font-family: 'SDSamliphopangche_Basic';
    src:
      url(${s3URL.mathflatAssetsBucket.font('SDSamliphopangcheBasic.otf')}) format('opentype'),
      url(${s3URL.mathflatAssetsBucket.font('SDSamliphopangcheTTFBasic.ttf')}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'NanumSquare';
    font-style: normal;
    font-weight: 800;
    src:
      url(${s3URL.mathflatAssetsBucket.font('NanumSquareEB.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('NanumSquareEB.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'NanumSquare';
    font-style: normal;
    font-weight: 700;
    src:
      url(${s3URL.mathflatAssetsBucket.font('NanumSquareB.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('NanumSquareB.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'NanumSquare';
    font-style: normal;
    font-weight: 500;
    src:
      url(${s3URL.mathflatAssetsBucket.font('NanumSquareR.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('NanumSquareR.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'NanumSquare';
    font-style: normal;
    font-weight: 300;
    src:
      url(${s3URL.mathflatAssetsBucket.font('NanumSquareL.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('NanumSquareL.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'Nanum Gothic';
    font-weight: 700;
    font-style: normal;
    src: url('${s3URL.mathflatAssetsBucket.font('nanum/NanumGothicBold.woff2')}') format('woff2');
  }

  @font-face {
    font-family: 'GmarketSansMedium';
    src:
      url(${s3URL.mathflatAssetsBucket.font('GmarketSansTTFMedium.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('GmarketSansMedium.otf')}) format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Noto Sans KR';
    font-style: normal;
    font-weight: 900;
    src:
      url(${s3URL.mathflatAssetsBucket.font('NotoSansKR-Black.woff2')}) format('woff2'),
      url(${s3URL.mathflatAssetsBucket.font('NotoSansKR-Black.woff')}) format('woff'),
      url(${s3URL.mathflatAssetsBucket.font('NotoSansKR-Black.otf')}) format('opentype');
  }

  @font-face {
    font-family: 'TmoneyRoundWind';
    src:
      url(${s3URL.mathflatAssetsBucket.font('TmoneyRoundWindExtraBold.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('TmoneyRoundWindExtraBold.otf')}) format('opentype');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'TmoneyRoundWind';
    src:
      url(${s3URL.mathflatAssetsBucket.font('TmoneyRoundWindExtraBold.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('TmoneyRoundWindExtraBold.otf')}) format('opentype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Cafe24SsurroundAir';
    src:
      url(${s3URL.mathflatAssetsBucket.font('Cafe24SsurroundAir-v1.1.ttf')}) format('truetype'),
      url(${s3URL.mathflatAssetsBucket.font('Cafe24SsurroundAir-v1.1.otf')}) format('opentype');
    font-weight: normal;
    font-style: normal;
  }
`
